/**
 * Codes are sent to the account's email address
 *
 * @type {string}
 */
export const TWO_FACTOR_CHANNEL_EMAIL = 'email';

/**
 * Codes are texted to the account's mobile number
 *
 * @type {string}
 */
export const TWO_FACTOR_CHANNEL_SMS = 'sms';

/**
 * Codes are generated by an authenticator app, never sent
 *
 * @type {string}
 */
export const TWO_FACTOR_CHANNEL_TOTP = 'totp';

/**
 * Number of digits in a verification code
 *
 * @type {number}
 */
export const TWO_FACTOR_CODE_LENGTH = 6;

/**
 * Seconds to wait between resend requests
 *
 * @type {number}
 */
export const TWO_FACTOR_RESEND_COOLDOWN = 60;

/**
 * Attempts allowed on a challenge before it is thrown away
 *
 * @type {number}
 */
export const TWO_FACTOR_MAX_ATTEMPTS = 5;

/**
 * Days the trusted device cookie is kept for
 *
 * @type {number}
 */
export const TWO_FACTOR_DEVICE_TOKEN_DAYS = 365;

/**
 * Channels a tenant may enrol in
 *
 * @type {string[]}
 */
export const TWO_FACTOR_ENROLLABLE_CHANNELS = [
  TWO_FACTOR_CHANNEL_EMAIL,
  TWO_FACTOR_CHANNEL_TOTP,
];

/**
 * Shape of the status endpoint, so the UI can rely on the keys being there
 *
 * @type {Object}
 */
export const TWO_FACTOR_STATUS_DEFAULTS = {
  channel: null,
  channels: [],
  enabled: false,
  mandatory: false,
  enabled_at: null,
  trusted_devices: 0,
  recovery_codes: {remaining: 0},
};

/**
 * @type {Object.<string, string>}
 */
export const TWO_FACTOR_CHANNEL_LABELS = {
  [TWO_FACTOR_CHANNEL_EMAIL]: 'Email',
  [TWO_FACTOR_CHANNEL_SMS]: 'Text message',
  [TWO_FACTOR_CHANNEL_TOTP]: 'Authenticator app',
};

/**
 * @type {Object.<string, string>}
 */
export const TWO_FACTOR_CHANNEL_DESCRIPTIONS = {
  [TWO_FACTOR_CHANNEL_EMAIL]:
    'We email you a 6-digit code each time you log in.',
  [TWO_FACTOR_CHANNEL_SMS]: 'We text you a 6-digit code each time you log in.',
  [TWO_FACTOR_CHANNEL_TOTP]:
    'An app such as Google Authenticator or 1Password generates a code for you. Nothing is sent, so it works without phone reception.',
};
